<div class="blog-container">
  <header class="blog-header">
    <h1>Blog</h1>
  </header>

  @if (loading) {
    <div class="loading">
      <div class="calculate-spinner-container" >
        <div class="spinner ng-tns-c1226552233-0">
          <div class="spinner-circle spinner-circle-outer"></div>
          <div class="spinner-circle-off spinner-circle-inner"></div>
          <div class="spinner-circle spinner-circle-single-1"></div>
          <div class="spinner-circle spinner-circle-single-2"></div>
        </div>
        <div class="text" style="text-align: center; width: 100%; top: 50%; position: relative; display: inline-block;"> ...Probíhá nahrávání článků... </div></div>
      </div>
    }

    @if (!loading) {
      <div class="articles-grid">
        @for (article of articles; track article) {
          <article class="article-card">
            <div class="card-image">
              <img [src]="article.image" [alt]="article.title" (error)="onImageError($event)" />
              @if (article.tags && article.tags.length > 0) {
                <div class="tags-container">
                  @for (tag of article.tags; track tag) {
                    <span class="tag">{{ tag }}</span>
                  }
                </div>
              }
            </div>
            <div class="card-content">
              <div class="author-section">
                @if (article.authorImage) {
                  <div class="author-avatar">
                    <img [src]="article.authorImage" [alt]="article.author" (error)="onAuthorImageError($event)" />
                  </div>
                }
                <div class="card-meta">
                  <span class="date">{{ article.date }}</span>
                  <span class="author">{{ article.author }}</span>
                </div>
              </div>
              <h2>{{ article.title }}</h2>
              <p class="summary">{{ article.summary }}</p>
              <button class="read-more-btn" (click)="readMore(article)">
                Pokračovat
              </button>
            </div>
          </article>
        }
      </div>
    }

    @if (!loading && articles.length === 0) {
      <div class="no-articles">
        <p>Zatím nejsou k dispozici žádné články.</p>
      </div>
    }
  </div>
